<?xml version="1.0" encoding="iso-8859-1"?>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<g>
		<path d="M459.922,142.012c-19.517-7.683-41.197-8.649-62.701-2.795c-16.371,4.458-32.004,12.617-46.698,24.346
			c-7.894-19.211-21.479-35.503-38.649-46.765c2.251-9.798,7.696-25.348,16.735-37.428c4.142,1.607,8.639,2.497,13.342,2.497
			c20.41,0,37.016-16.604,37.016-37.014c0-20.41-16.606-37.013-37.016-37.013s-37.014,16.604-37.014,37.014
			c0,4.05,0.664,7.946,1.871,11.597c-12.052,14.405-19.838,32.507-23.944,47.26c-8.564-2.337-17.57-3.592-26.865-3.592
			s-18.301,1.255-26.865,3.592c-4.105-14.753-11.892-32.854-23.944-47.26c1.208-3.651,1.871-7.547,1.871-11.597
			c0-20.41-16.604-37.014-37.014-37.014s-37.016,16.604-37.016,37.014c0,20.41,16.605,37.014,37.016,37.014
			c4.703,0,9.199-0.891,13.341-2.497c9.039,12.081,14.484,27.63,16.735,37.428c-17.17,11.263-30.755,27.554-38.649,46.765
			c-14.693-11.729-30.326-19.89-46.698-24.346c-21.505-5.856-43.185-4.888-62.701,2.795C20.262,154.541-0.18,182.618,0.001,213.546
			c0.104,17.88,7.185,35.349,20.476,50.515c10.824,12.352,25.56,23.057,43.94,31.943c-8.251,20.6-3.948,44.52,12.738,63.265
			c12.005,13.485,30.473,23.431,50.868,23.431c6.096,0,12.365-0.901,18.684-2.85c12.449,42.384,48.934,74.581,93.62,80.759v43.553
			h31.347v-43.553c44.686-6.178,81.171-38.375,93.62-80.759c6.319,1.949,12.587,2.849,18.684,2.849
			c20.392,0,38.864-9.947,50.868-23.431c16.687-18.744,20.99-42.665,12.738-63.265c18.38-8.886,33.115-19.591,43.94-31.943
			c13.291-15.166,20.371-32.633,20.476-50.515C512.18,182.618,491.74,154.541,459.922,142.012z M341.952,39.186
			c3.125,0,5.669,2.543,5.669,5.667c0,3.124-2.543,5.668-5.669,5.668c-3.124,0-5.668-2.543-5.668-5.668
			C336.285,41.729,338.828,39.186,341.952,39.186z M170.048,50.521c-3.125,0-5.669-2.543-5.669-5.668
			c0-3.124,2.543-5.667,5.669-5.667c3.124,0,5.668,2.543,5.668,5.667C175.715,47.978,173.173,50.521,170.048,50.521z M256,131.465
			c39.037,0,70.798,31.761,70.798,70.798c0,39.037-31.76,70.797-70.798,70.797c-39.038,0-70.798-31.761-70.798-70.798
			C185.202,163.225,216.963,131.465,256,131.465z M199.706,287.451c16.152,10.709,35.506,16.958,56.294,16.958
			c20.789,0,40.143-6.248,56.295-16.958c8.967,8.382,15.904,18.613,20.389,29.876H179.317
			C183.801,306.063,190.739,295.833,199.706,287.451z M142.112,348.044c-16.187,7.297-32.062,1.033-41.542-9.618
			c-8.48-9.526-14.018-25.515-1.717-39.222l15.258-17l-21.35-8.12c-38.889-14.79-61.274-36.92-61.413-60.72
			c-0.104-17.879,12.541-34.437,32.214-42.183c28.493-11.22,61.928-0.843,90.355,27.721c-0.037,1.116-0.062,2.235-0.062,3.36
			c0,24.224,8.481,46.5,22.623,64.029c-21.767,21.273-34.37,50.643-34.37,81.509C142.108,347.882,142.112,347.963,142.112,348.044z
			 M256,430.346c-23.374,0-44.494-9.781-59.526-25.447h119.052C300.494,420.563,279.375,430.346,256,430.346z M334.409,373.552
			H177.591c-2.583-7.845-4.022-16.201-4.113-24.879h165.044C338.431,357.351,336.992,365.707,334.409,373.552z M419.24,274.084
			l-21.35,8.12l15.258,17c12.302,13.707,6.765,29.696-1.717,39.222c-9.482,10.652-25.356,16.918-41.543,9.62
			c0-0.083,0.003-0.163,0.003-0.245c0-30.865-12.603-60.235-34.37-81.509c14.142-17.529,22.623-39.805,22.623-64.029
			c0-1.125-0.025-2.243-0.062-3.36c28.427-28.563,61.863-38.941,90.355-27.721c19.673,7.746,32.319,24.303,32.214,42.182
			C480.514,237.163,458.129,259.294,419.24,274.084z" style="fill:#aaa"/>
	</g>
</g>
<g>
	<g>
		<path d="M229.918,173.83c-5.671,0-10.285,4.661-10.285,10.418c0.001,5.756,4.615,10.422,10.285,10.422
			c5.678,0,10.291-4.665,10.291-10.422S235.596,173.83,229.918,173.83z" style="fill:#aaa"/>
	</g>
</g>
<g>
	<g>
		<path d="M282.005,173.749c-5.725,0-10.37,4.701-10.37,10.499c0,5.799,4.645,10.499,10.37,10.499c5.718,0,10.362-4.7,10.362-10.499
			C292.367,178.45,287.723,173.749,282.005,173.749z" style="fill:#aaa"/>
	</g>
</g>
</svg>
